// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/styles/variables.css */

:root {
    /* Cores */
    --color-text-white: #ffffff;
    --color-text-black: #1e1e1e;
    --color-text-grey: #5c5c5c;

    --color-l-logo: #074273;
    --color-i-logo: #f59c11;
    --color-f-logo: #00a0e4;
    --color-t-logo: #e6392f;

    --color-background-primary-white: #ffffff;
    --color-background-secondary-black: #1e1e1e;

    --color-accent: #28a745;
    --color-border: #00000050;
    --color-success: #06cf35;
    --color-error: #b30a1b;

    --color-instagram: #f55875;
    --color-facebook: #2852ac;
    --color-youtube: #ff0000;


    /* Fontes */
    --font-family-primary: 'Roboto', sans-serif;
    --font-family-secondary: 'Montserrat', sans-serif;
    --font-family-tertiary: 'Merriweather', serif;


    /* Tamanhos de Fonte */
    --font-size-h1-banner: 7vw;
    --font-size-h2-banner: 5vw;
    --font-size-h3-banner: 2vw;

    --font-size-h1: 32px;
    --font-size-h2: 24px;
    --font-size-h3: 18px;
    --font-size-h4: 15px;
    --font-size-h5: 16px;
    --font-size-h6: 17px;

    --font-size-body: 18px;
    --font-size-secondary: 15px;

    --font-size-menus: 16px;
    --font-size-buttons: 16px;
    --font-size-footers: 14px;

    --font-size-small: 12px;
    --font-size-large: 24px;


    /* Espaçamentos */
    --spacing-small: 0.5rem;
    --spacing-medium: 1rem;
    --spacing-large: 1.5rem;

    /* Margens e Preenchimentos */
    --margin-small: 0.5rem;
    --margin-medium: 1rem;
    --margin-large: 1.5rem;
    --margin-banner: 90px;

    --padding-small: 0.5rem;
    --padding-medium: 1rem;
    --padding-large: 1.5rem;

    /* Bordas */
    --border-radius-small: 4px;
    --border-radius-medium: 8px;
    --border-radius-large: 12px;
    --border-width: 1px;

    /* Sombras */
    --box-shadow-small: 0 2px 4px rgba(0, 0, 0, 0.1);
    --box-shadow-medium: 0 4px 8px rgba(0, 0, 0, 0.2);
    --box-shadow-large: 0 6px 12px rgba(0, 0, 0, 0.3);

    /* Transições */
    --transition-default: 0.3s ease;

    --max-width-container:100%;
}`, "",{"version":3,"sources":["webpack://./src/styles/Variable.css"],"names":[],"mappings":"AAAA,6BAA6B;;AAE7B;IACI,UAAU;IACV,2BAA2B;IAC3B,2BAA2B;IAC3B,0BAA0B;;IAE1B,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;;IAEvB,yCAAyC;IACzC,2CAA2C;;IAE3C,uBAAuB;IACvB,yBAAyB;IACzB,wBAAwB;IACxB,sBAAsB;;IAEtB,0BAA0B;IAC1B,yBAAyB;IACzB,wBAAwB;;;IAGxB,WAAW;IACX,2CAA2C;IAC3C,iDAAiD;IACjD,6CAA6C;;;IAG7C,sBAAsB;IACtB,0BAA0B;IAC1B,0BAA0B;IAC1B,0BAA0B;;IAE1B,oBAAoB;IACpB,oBAAoB;IACpB,oBAAoB;IACpB,oBAAoB;IACpB,oBAAoB;IACpB,oBAAoB;;IAEpB,sBAAsB;IACtB,2BAA2B;;IAE3B,uBAAuB;IACvB,yBAAyB;IACzB,yBAAyB;;IAEzB,uBAAuB;IACvB,uBAAuB;;;IAGvB,iBAAiB;IACjB,uBAAuB;IACvB,sBAAsB;IACtB,uBAAuB;;IAEvB,6BAA6B;IAC7B,sBAAsB;IACtB,qBAAqB;IACrB,sBAAsB;IACtB,qBAAqB;;IAErB,uBAAuB;IACvB,sBAAsB;IACtB,uBAAuB;;IAEvB,WAAW;IACX,0BAA0B;IAC1B,2BAA2B;IAC3B,2BAA2B;IAC3B,mBAAmB;;IAEnB,YAAY;IACZ,gDAAgD;IAChD,iDAAiD;IACjD,iDAAiD;;IAEjD,eAAe;IACf,+BAA+B;;IAE/B,0BAA0B;AAC9B","sourcesContent":["/* src/styles/variables.css */\r\n\r\n:root {\r\n    /* Cores */\r\n    --color-text-white: #ffffff;\r\n    --color-text-black: #1e1e1e;\r\n    --color-text-grey: #5c5c5c;\r\n\r\n    --color-l-logo: #074273;\r\n    --color-i-logo: #f59c11;\r\n    --color-f-logo: #00a0e4;\r\n    --color-t-logo: #e6392f;\r\n\r\n    --color-background-primary-white: #ffffff;\r\n    --color-background-secondary-black: #1e1e1e;\r\n\r\n    --color-accent: #28a745;\r\n    --color-border: #00000050;\r\n    --color-success: #06cf35;\r\n    --color-error: #b30a1b;\r\n\r\n    --color-instagram: #f55875;\r\n    --color-facebook: #2852ac;\r\n    --color-youtube: #ff0000;\r\n\r\n\r\n    /* Fontes */\r\n    --font-family-primary: 'Roboto', sans-serif;\r\n    --font-family-secondary: 'Montserrat', sans-serif;\r\n    --font-family-tertiary: 'Merriweather', serif;\r\n\r\n\r\n    /* Tamanhos de Fonte */\r\n    --font-size-h1-banner: 7vw;\r\n    --font-size-h2-banner: 5vw;\r\n    --font-size-h3-banner: 2vw;\r\n\r\n    --font-size-h1: 32px;\r\n    --font-size-h2: 24px;\r\n    --font-size-h3: 18px;\r\n    --font-size-h4: 15px;\r\n    --font-size-h5: 16px;\r\n    --font-size-h6: 17px;\r\n\r\n    --font-size-body: 18px;\r\n    --font-size-secondary: 15px;\r\n\r\n    --font-size-menus: 16px;\r\n    --font-size-buttons: 16px;\r\n    --font-size-footers: 14px;\r\n\r\n    --font-size-small: 12px;\r\n    --font-size-large: 24px;\r\n\r\n\r\n    /* Espaçamentos */\r\n    --spacing-small: 0.5rem;\r\n    --spacing-medium: 1rem;\r\n    --spacing-large: 1.5rem;\r\n\r\n    /* Margens e Preenchimentos */\r\n    --margin-small: 0.5rem;\r\n    --margin-medium: 1rem;\r\n    --margin-large: 1.5rem;\r\n    --margin-banner: 90px;\r\n\r\n    --padding-small: 0.5rem;\r\n    --padding-medium: 1rem;\r\n    --padding-large: 1.5rem;\r\n\r\n    /* Bordas */\r\n    --border-radius-small: 4px;\r\n    --border-radius-medium: 8px;\r\n    --border-radius-large: 12px;\r\n    --border-width: 1px;\r\n\r\n    /* Sombras */\r\n    --box-shadow-small: 0 2px 4px rgba(0, 0, 0, 0.1);\r\n    --box-shadow-medium: 0 4px 8px rgba(0, 0, 0, 0.2);\r\n    --box-shadow-large: 0 6px 12px rgba(0, 0, 0, 0.3);\r\n\r\n    /* Transições */\r\n    --transition-default: 0.3s ease;\r\n\r\n    --max-width-container:100%;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
